import { render, staticRenderFns } from "./DisableCourier.vue?vue&type=template&id=253f2c30"
import script from "./DisableCourier.vue?vue&type=script&lang=js"
export * from "./DisableCourier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports